<script setup>
import { computed } from 'vue'

const props = defineProps({
  override: {
    type: Boolean,
    default: false
  },
  icon: {
    type: String,
    required: true
  },
  size: {
    type: String,
    default: 'fa-lg'
  }
})

const frtIcon = computed(() => {
  return `fak fa-frt-${props.icon} ${props.size}`
})
</script>

<template>
  <i :class="override ? `${icon} ${size}` : `${frtIcon} ${size}`" />
</template>
1
